import { defineComponent } from '@vue/composition-api';
export default defineComponent({
    name: 'DpTableExtraHeader',
    props: {
        colspan: { type: Number, default: 1 },
    },
});
